/* global d3:true */
import pym from 'pym.js';
import throttle from 'lodash.throttle';

// new pym child instance
const pymChild = new pym.Child();

// setting margins for d3 chart
const margin = { top: 10, right: 30, bottom: 20, left: 60 };

// grabbing initial window width
let windowWidth = window.innerWidth;

// selecting the svg container and finding its width to use as the base
// of the d3 chart width
const svgContainer = document.querySelector('#svg__container');
const graphicWidth = svgContainer.offsetWidth;

// drawing the grapghic
function drawGraphic() {
  // clearing the html of the graphic so as not to duplicate the
  // chart on a window resize redraw function
  d3.select('#pop-change__chart').html('');

  // setting up the dimensions of the chart
  const width = graphicWidth - margin.left - margin.right;
  const height = 300 - margin.top - margin.bottom;

  // drawing and placing the initial svg element
  const svg = d3.select('#pop-change__chart')
    .append('svg')
    .attr('width', width + margin.left + margin.right)
    .attr('height', height + margin.top + margin.bottom)
    .attr('fill', 'red')
    .append('g')
    .attr('transform', `translate(${margin.left},${margin.top})`);

  // setting placeholders for the x and y scale
  let x;
  let y;

  // data draw for the prison pop change
  d3.csv('https://splc-git.github.io/la-da-sheriffs/embeds/line-chart/data/pop-change.csv')
    .row(d => ({ year: d3.timeParse('%Y')(d.year), prison: d.prison, jail: d.jail }))
    .get((data) => {
      // setting the x scale and drawing the axis
      x = d3.scaleTime()
        .domain(d3.extent(data, d => d.year))
        .range([0, width]);
        
      const xValues = [d3.timeParse('%Y')(1983), d3.timeParse('%Y')(1990), d3.timeParse('%Y')(2000), d3.timeParse('%Y')(2010), d3.timeParse('%Y')(2020)];

      svg.append('g')
        .attr('transform', `translate(0,${height})`)
        .attr('class', 'axis x-axis')
        .call(d3.axisBottom(x).ticks(5).tickValues(xValues));

      // popluating an array of y values to help determine max value
      const values = [];

      data.forEach((d) => {
        values.push(+d.prison);
        values.push(+d.jail);
      });

      // finding max y value
      const maxValue = d3.max(values);
       

      // defining the y scale and drawing the y axis
      y = d3.scaleLinear()
        .domain([0, maxValue])
        .range([height, 0]);
  
      svg.append('g')
        .attr('class', 'axis y-axis')
        .call(d3.axisLeft(y).ticks(4));

      // adding the path for the prison population
      svg.append('path')
        .datum(data)
        .attr('fill', 'none')
        .attr('stroke', '#FF4301')
        .attr('stroke-width', 1.5)
        .attr('d', d3.line()
          .x(d => x(d.year))
          .y(d => y(d.prison)),
        );

      // drawing the lines and text for the legend
      // svg.append('div')
      //   .attr('class', 'legend__item')
      //   .append('line')
      //   .attr('x1', 0)
      //   .attr('x2', 40)
      //   .attr('y1', height + margin.top + 30)
      //   .attr('y2', height + margin.top + 30)
      //   .attr('stroke', '#000000')
      //   .style('stroke-dasharray', ('3, 3'))
      //   .attr('stroke-width', 1.5);

      // svg.append('text')
      //   .attr('x', 45)
      //   .attr('y', height + margin.top + 33)
      //   .text('Jail Population')
      //   .attr('class', 'legend__label');

      // svg.append('line')
      //   .attr('x1', 140)
      //   .attr('x2', 180)
      //   .attr('y1', height + margin.top + 30)
      //   .attr('y2', height + margin.top + 30)
      //   .attr('stroke', '#FF4301')
      //   .attr('stroke-width', 1.5);

      // svg.append('text')
      //   .attr('x', 185)
      //   .attr('y', height + margin.top + 33)
      //   .text('Prison Population')
      //   .attr('class', 'legend__label');
    });

  // drawing the data from the jail population. Since the jail pop does
  // not have figures for each year, we've broken the data out into
  // it's own file for easier drawing of the line

  d3.csv('https://splc-git.github.io/la-da-sheriffs/embeds/line-chart/data/pop-change-jail.csv')
    .row(d => ({ year: d3.timeParse('%Y')(d.year), jail: d.jail }))
    .get((data) => {
      svg.append('path')
        .datum(data)
        .attr('fill', 'none')
        .attr('stroke', '#000000')
        .style('stroke-dasharray', ('3, 3'))
        .attr('stroke-width', 1.5)
        .attr('d', d3.line()
          .x(d => x(d.year))
          .y(d => y(d.jail)),
        );
    });
}

// do the initial graphic draw
drawGraphic();

// listen for window resizes, and if the width changes,
// redraw the graphic. Upon redraw, the graphic svg will be
// cleared, new width for the parent element will be pulled, and
// that new width will serve as the new base width of the graphic
// we also throttle this resize event listener so as to reduce the number
// of redraws per window resize
window.addEventListener('resize', throttle(() => {
  const newWindowWidth = window.innerWidth;

  if (newWindowWidth !== windowWidth) {
    drawGraphic();
    windowWidth = newWindowWidth;

    pymChild.sendHeight();
  }
}), 250);

pymChild.sendHeight();
